var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0L44.7846 34.5H3.21539L24 0Z",
    fill: "#FDD09F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.3636L23.8864 23.7273H22.5682L22.4545 15.3636H24ZM23.2273 27.0909C22.947 27.0909 22.7064 26.9905 22.5057 26.7898C22.3049 26.589 22.2045 26.3485 22.2045 26.0682C22.2045 25.7879 22.3049 25.5473 22.5057 25.3466C22.7064 25.1458 22.947 25.0455 23.2273 25.0455C23.5076 25.0455 23.7481 25.1458 23.9489 25.3466C24.1496 25.5473 24.25 25.7879 24.25 26.0682C24.25 26.2538 24.2027 26.4242 24.108 26.5795C24.017 26.7348 23.8939 26.8598 23.7386 26.9545C23.5871 27.0455 23.4167 27.0909 23.2273 27.0909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationError);
export default __webpack_public_path__ + "static/media/notificationError.3d4d928b1fa66c1363b44571c2e5f146.svg";
export { ForwardRef as ReactComponent };